module.exports = __webpack_public_path__ + "media/images/front/confirmations_done/sidebar-fc92bdcf20e3ee52d37c73b3b838704e.png";